import React, { useState, useEffect } from 'react';
import './PosterHeader.css';
import { useNavigate } from 'react-router-dom';
import { useTransition } from '../../../contexts/TransitionContext';

function PosterHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State for toggle menu
  const navigate = useNavigate();
  const { goToHome, goToArt, goToPosters } = useTransition();

  const handleHomeClick = () => {
    goToHome();
    navigate("/");
  };

  const handlePosterClick = () => {
    goToPosters();
    navigate("/posters");
  };

  const handleParedoliaClick = () => {
    goToArt();
    navigate("/paredolia"); // Ensure this is the correct path for the art page
  };

  const handlePondClick = () => {

    navigate("/button"); // Ensure this is the correct path for the art page
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the menu visibility
  };

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const menuActions = {
    'Home': handleHomeClick,
    'Posters': handlePosterClick,
    'Paredolia':  handleParedoliaClick,
    'My Bed': handlePondClick
  };

  const menuItems = ['Home', 'Posters', 'Paredolia', 'My Bed'];

  return (
    <header className={`header ${isScrolled ? 'visible' : ''}`}>
      <div className="burger-menu" onClick={toggleMenu}>
        ☰
      </div>
      <div className={`title ${isScrolled ? 'scrolled' : ''}`}>

        <span style={{ color: '#DDB514' }} className="letter">h</span>
        <span style={{ color: '#ef4343' }} className="letter">a</span>
        <span style={{ color: '#5190CB' }} className="letter">b</span>
        <span style={{ color: '#ed9aff' }} className="letter">b</span>
        <span style={{ color: '#95d35a' }} className="letter">y</span>

      </div>
      <div className="divider"></div>

      <nav className={`menu ${isMenuOpen ? 'open' : ''}`}>
        {menuItems.map((item) => (
          <React.Fragment key={item}>
            <button className="menu-item" onClick={menuActions[item]}>{item}</button>
            {item !== 'Contact' && <div className="divider"></div>}
          </React.Fragment>
        ))}
      </nav>
    </header>
  );
}

export default PosterHeader;
